import * as React from 'react';
import { SVGProps } from 'react';

const IconFlagStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m18 9 3 7H5v6H3V2h18l-3 7zm-.033 5H5V4h12.967l-2.143 5 2.143 5z"
    />
  </svg>
);
export default IconFlagStrokedSizeM;
